import axios from "axios";
import { baseURL } from "./configs"

const instance = axios.create({
    baseURL: baseURL,
    validateStatus: function validateStatus(status) {
        let default_ = status >= 200 && status < 300;
        let extra = status == 404 // || status == 402 || status == 403
        return default_ || extra
    }
});

instance.defaults.headers.post['Content-Type'] = 'application/json';

instance.interceptors.request.use(
    config => {
        const token = global.get_token()
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

export default instance;